import { render, staticRenderFns } from "./Socials.vue?vue&type=template&id=71e3040c&scoped=true&"
import script from "./Socials.vue?vue&type=script&lang=js&"
export * from "./Socials.vue?vue&type=script&lang=js&"
import style0 from "./Socials.vue?vue&type=style&index=0&id=71e3040c&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "71e3040c",
  null
  
)

export default component.exports